import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getAllSilos = async (filters, page, size) => {
  try {
    const response = await api.get(`/silo`, {
      headers: setAuthHeader(),
      params: {
        ...filters,
        page,
        size,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const createSilo = async (siloData) => {
  try {
    const response = await api.post('/silo', siloData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error creating silo');
  }
};

export const getSiloData = async (siloId) => {
  try {
    const response = await api.get(`/silo/${siloId}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar dados do silo.');
  }
};

export const updateSilo = async (siloId, data) => {
  try {
    const response = await api.put(`/silo/${siloId}`, data, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar o silo.');
  }
};